import axios from "axios";
import {headers} from "@/services/headers"
import {ThunkAction} from "@reduxjs/toolkit";
import {RootState} from "../store";
import {getErrors, loading, setAffiliator, setAffiliatorDeleted, setAffiliators, setPaginator} from "@/reducers/affiliators";

export const GetAffiliators = (eventCode?: string, query?: string, page = 1):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .get(process.env.REACT_APP_BASE_URL + '/org/events/' + eventCode + '/affiliators?filter[search]=' + query + '&page=' + page, {
            headers: headers()
        }).then((response) => {
            dispatch(setAffiliators(response.data.data));
            dispatch(setPaginator(response.data.meta));

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};

export const StoreAffiliator = (eventId: number, attributes: {name: string, email: string}):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .post(process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/affiliators', attributes, {
            headers: headers()
        }).then((response) => {
            dispatch(setAffiliator(response.data.data));

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};

export const DeleteAffiliator = (eventId: number, affiliatorId: number):  ThunkAction<void, RootState, unknown, any> => async (dispatch: any) => {
    dispatch(loading(true))

    return axios
        .delete(process.env.REACT_APP_BASE_URL + '/org/events/' + eventId + '/affiliators/' + affiliatorId, {
            headers: headers()
        }).then(() => {
            dispatch(setAffiliatorDeleted(affiliatorId));

            dispatch(loading(false))
        }).catch((error: any) => {
            const {errors, message} = error.response.data.error;

            dispatch(getErrors({
                errorMsg: message,
                errors: errors,
            }));

            dispatch(loading(false))
        });
};
